/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DeviceUpdate = {
    properties: {
        info: {
            type: 'string',
            isRequired: true,
        },
        deviceId: {
            type: 'string',
            isRequired: true,
        },
        firebaseToken: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        appVersion: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
